import { Column, Container, Section, Row } from "@react-email/components";
import { EmailLink } from "@/email/components/EmailLink";
import { SiteRoutes } from "@/types/routes";
import { ITenant } from "@/types/tenant";

const footerLinkStyle = {
    fontSize: "14px",
    color: "#303330",
    fontWeight: 500,
    lineHeight: 1.2,
};

export const EmailFooter = ({ tenant }: { tenant: ITenant | null }) => {
    const { name, externalLinks, subdomain } = tenant ?? {};
    const { termsOfService, privacyPolicy } = externalLinks ?? {};
    return (
        <Container
            style={{
                marginTop: "52px",
                borderTop: "2px solid #CED4E5",
                display: "flex",
                justifyContent: "flex-end",
                padding: "16px",
                textAlign: "center",
                fontSize: "14px",
            }}
        >
            <Section>
                <Row>
                    <Column>
                        <EmailLink
                            href={`https://${subdomain}.1template.io`}
                            style={footerLinkStyle}
                        >
                            {name}
                        </EmailLink>
                    </Column>
                    <Column style={{ paddingLeft: "12px" }}>
                        <EmailLink
                            href={externalLinks?.homepage || SiteRoutes.About}
                            style={footerLinkStyle}
                        >
                            About
                        </EmailLink>
                    </Column>
                    <Column style={{ paddingLeft: "12px" }}>
                        <EmailLink
                            href={privacyPolicy || SiteRoutes.PrivacyPolicy}
                            style={footerLinkStyle}
                        >
                            Privacy
                        </EmailLink>
                    </Column>
                    <Column style={{ paddingLeft: "12px" }}>
                        <EmailLink
                            href={termsOfService || SiteRoutes.Terms}
                            style={footerLinkStyle}
                        >
                            Terms
                        </EmailLink>
                    </Column>
                </Row>
            </Section>
        </Container>
    );
};
